<template>
    <!-- <TransitionGroup appear name="prod_box_animation" tag="div"  class="row listing-container-min-height"> -->
        <div class="row listing-container-min-height">
        <div 
            :class="data.isQuiz == true ? 'col-lg-12 col-md-12 col-12' : 'col-lg-3 col-md-4 col-6'"
            class="diam_block" 
            v-for="data in products"  
            :style="{ transitionDelay: `${data.transitionDelayKey * 30}ms` }" 
            :key="data.uniqueKey"
        >
           
            <div v-if="data.isQuiz" class="quiz_box">
                <ModalLooseDiamondQuiz />
            </div>
            <div v-else>
                <div class="diam_box skeleton_box border-0" v-if="data.key === 'empty_state'">
                    <img src="@/assets/assets/skeleton.jpg" width="600" height="600" alt="loading skeleton">
                    <p class="placeholder-glow mb-0 mt-2">
                        <span class="placeholder col-12 p-3"></span>
                        <span class="placeholder col-8 p-2 my-2"></span>
                        <span class="placeholder col-5 p-2"></span>
                    </p>
                </div>
                <div class="diam_box" v-else>
                    <router-link class="for_desktop img-container" :to="localePath(detailPath(data.slug))" @click="triggerGtag(data)">
                        <!-- <b-img loading="lazy" height="300" width="300" :src="data.thumb_image" :alt="`${data.carat} carat ${data.color} ${data.clarity} ${data.cut} Cut ${data.report} ${data.shape} diamond`"></b-img> -->
                        <nuxt-img :src="data.thumb_image" :alt="`${data.carat} carat ${data.color} ${data.clarity} ${data.cut} Cut ${data.report} ${data.shape} diamond`" placeholder />
                        <span class="fiery" v-if="data.is_fiery_round === 1">Fiery Round</span>
                    </router-link>
                    <div class="for_mobile img-container" @click="handleQuickView(data)">
                        <nuxt-img :src="data.thumb_image" placeholder :alt="data.carat + ' carat ' + data.shape + ' diamond thumb image'" />
                        <span class="fiery" v-if="data.is_fiery_round === 1">Fiery Round</span>
                    </div>
                    <div class="diam_details p-3">
                        <div class="">
                            <p class="mb-1">{{ data.carat }} carat {{ data.shape }} diamond</p>
                            <div class="four_cs">
                                {{ data.color }} 
                                <span>|</span> 
                                {{ data.clarity }} 
                                <span>|</span> 
                                {{ data.cut }} 
                                <span>|</span> 
                                {{ data.report }}
                            </div>
                            
                        </div>
                        <div class="d-flex align-items-center justify-content-between grid_price mt-3">
                            <h4 class="mb-0">{{ $formatPrice(data.price) }} 
                                <!-- <span>{{ $formatPrice(data.price) }}</span> -->
                            </h4>
                            <div class="for_desktop">
                                <div class="checkbox_custom tooltip_box" @click="addDiamondToCompare(data)">
                                    <span :class="{ 'checked': data.is_compared_count === 1, 'unchecked': data.is_compared_count === 0 }"></span>
                                    <label class="mb-0"></label>
                                    <div class="tooltip_text" v-if="data.is_compared_count === 0">Add to Compare</div>
                                    <div class="tooltip_text" v-if="data.is_compared_count === 1">Remove from Compare</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <CyoLooseQuickViewDiamondQuickView 
            class="for_mobile"  
            :data="quickViewProduct" 
            :openQuickDiamondView="openQuickDiamondView"
            @closeDiamondQuickView="closeDiamondQuickView"  
            @openDetailsPage="openDetailsPage"
        />
    </div>
    <!-- </TransitionGroup> -->
</template>


<script setup>
   import {compareStore}  from '@/stores/diamond_compare/diamond_compare';
    import {cyolistStore}  from '@/stores/cyolist/cyolist';
    const localePath = useLocalePath()
    const router = useRouter()

    const quickViewProduct= ref(null)
    const openQuickDiamondView = ref(false)



    const {$looseViewGtag , $formatPrice, $toast} = useNuxtApp()

    // Use Vuex store
    const store = cyolistStore()
    const storeCompare = compareStore()

    // Inject moduleSubType
    const moduleSubType = inject('moduleSubType')


    // Computed properties
    const products = computed(() => store.getSettingListingResult())
    const showSkeleton = computed(() => store.getSettingShowSkeleton())

    // Methods
    const triggerGtag = (data) => {
        if (moduleSubType === 'loose') {
            $looseViewGtag(data)
        }
    }

    const detailPath = (slug) => {
        if (['ring', 'earring', 'pendant'].includes(moduleSubType)) {
            return { name: 'cyo-diamond-detail-' + moduleSubType, params: { slug } }
        }
        return { name: 'loose-detail', params: { slug } }
    }

    const addDiamondToCompare = (diamond) => {
        storeCompare.addToCompare( { type: moduleSubType, diamond })
            .then((res) => {
                $toast('success', res.status, res.msg);
                // store.dispatch('toast', { type: 'success', title: res.status, text: res.msg })
            })
    }

    const openDiamondQuickView = (data)=>{
        document.body.classList.add('filter_open');
        quickViewProduct.value = data
        
        nextTick(()=>{
            openQuickDiamondView.value = true
        })
    }

    const closeDiamondQuickView = ()=>{
        document.body.classList.remove('filter_open');
        openQuickDiamondView.value = false
        // setTimeout(()=>{
        //     quickViewProduct.value = null
        // },500) 
    }

    const openDetailsPage = (slug)=>{
       closeDiamondQuickView()
       router.push(localePath(detailPath(slug)))   
    }

    const handleQuickView = (data)=>{
        triggerGtag(data)
        openDiamondQuickView(data)
    }

</script>
<style scoped>
.quiz_box {
    margin-bottom: 30px;
}

.diam_box {
    border: solid 1px #e2e2e2;
    margin-bottom: 30px;
    border-radius: 8px;
}
.diam_box:hover{
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.15);

}
.diam_box p {
    color: #353535;
    font-size: 18px;
    line-height: 1.5;
    text-transform: capitalize;
    font-weight: 600;
    min-height: 50px;
}
.four_cs {
    display: block;
    color: #353535;
    font-size: 16px;
    font-weight: 500;
    text-transform: uppercase;
}

.four_cs span {
    color: #c4c4c4;
}

.diam_box {
    position: relative;
}

.fiery {
    color: #353535 !important;
    font-size: 14px;
    font-weight: 500;
    text-transform: capitalize !important;
    /* margin: 2px; */
    background: #668b844c;
    padding: 2px 8px;
    border-radius: 4px;
    position: absolute;
    left: 8px;
    top: 8px;

}


.diam_box .img-container img {
    min-height: 280px;
    object-fit: cover;
    max-height: 280px;
    width: 100%;
    border-radius: 6px 6px 0 0;
}
.diam_box h4 {
    color: var(--green);
    font-size: 20px;
    font-weight: 600;
    display: flex;
    align-items: center;
}
.diam_box h4 span {
    color: #909090;
    font-size: 16px;
    font-weight: 500;
    text-decoration: line-through;
}
.compare_icons {
    cursor: pointer;
}

@media(max-width: 1250px) {
    .diam_box .img-container img {
        height: 220px;
    }
}
@media(max-width: 1100px) {
    .diam_box .img-container img {
        height: 200px;
        min-height: auto;
    }
}
@media(max-width: 1024px) {
    .diam_box p {
        min-height: 73px;
    }
}
@media(max-width: 992px) {
    .diam_box .img-container img {
        min-height: 280px;
    }
}
@media(max-width: 767px) {
    .quiz_box {
        margin-bottom: 0;
    }
    .four_cs{
        font-size: 14px;
    }
    /* .diam_block:nth-child(2n+2) {
        padding: 0;
        padding-right: 12px;
        padding-left: 5px;
    }
    .diam_block:nth-child(2n+1) {
        padding: 0;
        padding-left: 12px;
        padding-right: 5px;
    } */
     
    .diam_block {
        margin-bottom: 10px !important;
        padding: 0 7px !important;
    }
    .diam_box p {
        min-height: 42px;
    }
    .diam_box .img-container img {
        min-height: 335px;
        max-height: inherit;
    }
    .diam_box img {
        width: 20px;
    }
    .diam_details {
        padding: 8px !important;
    }
    .diam_box p {
        font-size: 14px;
    }
    .diam_box h4 {
        color: var(--green);
        font-size: 16px;
    }
    .diam_box h4 span {
    font-size: 12px;
    margin-left: 5px;
}
    .grid_price {
        margin: 7px 0 5px !important;
    }
    .diam_details a button {
        height: 30px !important;
    }
    .diam_box {
        margin-bottom: 0;
    }
    .skeleton_box img {
    width: 100%;
}
}
@media(max-width: 650px) {
    .diam_box .img-container img {
        min-height: 250px;
    }
}
@media(max-width: 512px) {
    .diam_box .img-container img {
        min-height: 175px;
    }
}
.fade-enter-active {
    transition: opacity 0.5s ease-in-out;
}
.fade-leave-active {
    display: none;
    transition: opacity 0;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
